module.exports = __webpack_public_path__ + "static/media/silver.70067bd6.png";